'use client';

import { Tooltip as TooltipPrimitive } from 'radix-ui';
import * as React from 'react';

import { TOOLTIP_DELAY, tooltipStyles } from '../lib/tooltip-styles';

/**
 * Wrap the app once (root layout). Figma: 400ms delay in; Radix closes
 * immediately (0ms out) and skips the delay when moving between triggers.
 */
function TooltipProvider({
  delayDuration = TOOLTIP_DELAY,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

/** shadcn TooltipContent, restyled to the Figma Tooltip body and 12×6 arrow. */
function TooltipContent({
  className,
  sideOffset = 4,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  const styles = tooltipStyles();
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={styles.content({ className })}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow width={12} height={6} className={styles.arrow()} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
